export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mb-8">
          <div className="lg:col-span-2">
            <div className="mb-6">
              <a href="#" className="block">
                <img
                  src="https://static.readdy.ai/image/2806d7657d5f4d36c9110f806a03accf/910b3437c1bd90dd0b8d72d486f1f6c6.png"
                  alt="Gavin Luke Tree and Stump Service Logo"
                  className="h-40 w-auto"
                />
              </a>
            </div>
            <p className="text-gray-300 mb-6 text-lg max-w-md">
              Professional tree and stump removal services you can trust. Licensed, insured, and committed to safety and customer satisfaction.
            </p>
            <div className="flex flex-wrap gap-4 mb-6">
              <div className="flex items-center space-x-2">
                <i className="fas fa-certificate text-green-600"></i>
                <span className="text-sm text-gray-300">Licensed and Insured</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="fas fa-clock text-green-600"></i>
                <span className="text-sm text-gray-300">24/7 Emergency</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-gray-300 hover:text-green-600 transition-colors duration-200 cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-green-600 transition-colors duration-200 cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-green-600 transition-colors duration-200 cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-gray-300 hover:text-green-600 transition-colors duration-200 cursor-pointer"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('quote')}
                  className="text-gray-300 hover:text-green-600 transition-colors duration-200 cursor-pointer"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Contact Info</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="fas fa-phone text-green-600 mt-1"></i>
                <div>
                  <p className="font-semibold">0411 597 232</p>
                  <p className="text-sm text-gray-400">Call or Text Anytime</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="fas fa-envelope text-green-600 mt-1"></i>
                <div>
                  <p className="font-semibold break-all">gavin@gavinluketreeandstumpservice.com</p>
                  <p className="text-sm text-gray-400">Email for Quotes</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="fas fa-map-marker-alt text-green-600 mt-1"></i>
                <div>
                  <p className="font-semibold">Barossa Valley, SA</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-600 pt-8 mb-8">
          <h3 className="text-xl font-bold mb-4 text-center">Our Services</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 text-center">
            <div className="text-gray-300">
              <i className="fas fa-tree text-2xl text-green-600 mb-2 block"></i>
              <p className="text-sm">Tree Removal</p>
            </div>
            <div className="text-gray-300">
              <i className="fas fa-cog text-2xl text-green-600 mb-2 block"></i>
              <p className="text-sm">Stump Grinding</p>
            </div>
            <div className="text-gray-300">
              <i className="fas fa-cut text-2xl text-green-600 mb-2 block"></i>
              <p className="text-sm">Tree Trimming</p>
            </div>
            <div className="text-gray-300">
              <i className="fas fa-exclamation-triangle text-2xl text-green-600 mb-2 block"></i>
              <p className="text-sm">Emergency Services</p>
            </div>
            <div className="text-gray-300">
              <i className="fas fa-truck text-2xl text-green-600 mb-2 block"></i>
              <p className="text-sm">Debris Removal</p>
            </div>
            <div className="text-gray-300">
              <i className="fas fa-seedling text-2xl text-green-600 mb-2 block"></i>
              <p className="text-sm">Land Clearing</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-600 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
            <div className="text-center lg:text-left">
              <p className="text-gray-400">
                © 2025 Gavin Luke Tree and Stump Service. All rights reserved.
              </p>
              <p className="text-gray-500 text-sm mt-1">
                Built by{' '}
                <a
                  href="https://newpathautomation.com.au/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="hover:text-green-600 transition-colors"
                >
                  Newpath Automation
                </a>
              </p>
            </div>
            <div>
              <button
                onClick={() => scrollToSection('quote')}
                className="inline-flex items-center bg-green-600 text-white hover:bg-green-700 px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="fas fa-phone mr-2"></i>
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
